import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { canAccessPath } from '../utils/roles'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: () => import('../views/Landing.vue'),
    meta: {
      public: true,
      title: '灵犀资产 · FAMS',
      description: '灵犀资产 · FAMS：AI视觉建档拍物品识别分类、RFID标签打印到扫码盘点全链路、内置国标GB/T 14885分类，开箱即用贴合审计。'
    }
  },
  {
    path: '/login',
    component: () => import('../views/Login.vue'),
    meta: { public: true, noindex: true, title: '登录' }
  },
  {
    path: '/register',
    component: () => import('../views/Register.vue'),
    meta: { public: true, noindex: true, title: '免费试用' }
  },
  {
    path: '/',
    name: 'AppShell',
    component: () => import('../views/Layout.vue'),
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('../views/Dashboard.vue'), meta: { title: '首页', icon: 'el-icon-s-home' } },
      { path: 'aiArchive', name: 'AiArchive', component: () => import('../views/asset/AiArchive.vue'), meta: { title: 'AI 智能建档', icon: 'el-icon-camera', group: 'AI 智能' } },
      { path: 'assetList', name: 'AssetList', component: () => import('../views/asset/AssetList.vue'), meta: { title: '资产列表', icon: 'el-icon-goods' } },
      { path: 'assetQuery', name: 'AssetQuery', component: () => import('../views/asset/AssetQuery.vue'), meta: { title: '资产查询', icon: 'el-icon-search' } },
      { path: 'assetCategory', name: 'AssetCategory', component: () => import('../views/asset/AssetCategory.vue'), meta: { title: '资产分类', icon: 'el-icon-menu' } },
      { path: 'assetExpire', name: 'AssetExpire', component: () => import('../views/asset/AssetExpire.vue'), meta: { title: '到期提醒', icon: 'el-icon-warning' } },
      { path: 'deviceManage', name: 'DeviceManage', component: () => import('../views/asset/DeviceManage.vue'), meta: { title: '读写器管理', icon: 'el-icon-cpu' } },

      { path: 'requisition', name: 'Requisition', component: () => import('../views/requisition/RequisitionList.vue'), meta: { title: '领用列表', icon: 'el-icon-s-check' } },
      { path: 'requisitionApprove', name: 'RequisitionApprove', component: () => import('../views/requisition/RequisitionApprove.vue'), meta: { title: '领用初级审核', icon: 'el-icon-check' } },
      { path: 'requisitionApprove2', name: 'RequisitionApprove2', component: () => import('../views/requisition/RequisitionApprove2.vue'), meta: { title: '领用终级审核', icon: 'el-icon-finished' } },
      { path: 'requisitionIssue', name: 'RequisitionIssue', component: () => import('../views/requisition/RequisitionIssue.vue'), meta: { title: '领用发放', icon: 'el-icon-s-claim' } },
      { path: 'requisitionReturn', name: 'RequisitionReturn', component: () => import('../views/requisition/RequisitionReturn.vue'), meta: { title: '领用归还', icon: 'el-icon-refresh-left' } },
      { path: 'requisitionCancel', name: 'RequisitionCancel', component: () => import('../views/requisition/RequisitionCancel.vue'), meta: { title: '取消审核', icon: 'el-icon-close' } },

      { path: 'inventory', name: 'Inventory', component: () => import('../views/inventory/InventoryList.vue'), meta: { title: '盘点管理', icon: 'el-icon-s-data' } },

      { path: 'purchase', name: 'Purchase', component: () => import('../views/purchase/PurchaseList.vue'), meta: { title: '采购列表', icon: 'el-icon-shopping-cart-2' } },
      { path: 'purchaseApprove1', name: 'PurchaseApprove1', component: () => import('../views/purchase/PurchaseApprove1.vue'), meta: { title: '初级审核', icon: 'el-icon-check' } },
      { path: 'purchaseApprove2', name: 'PurchaseApprove2', component: () => import('../views/purchase/PurchaseApprove2.vue'), meta: { title: '终级审核', icon: 'el-icon-finished' } },
      { path: 'purchaseConfirm', name: 'PurchaseConfirm', component: () => import('../views/purchase/PurchaseConfirm.vue'), meta: { title: '确认采购', icon: 'el-icon-s-claim' } },
      { path: 'purchaseCancel', name: 'PurchaseCancel', component: () => import('../views/purchase/PurchaseCancel.vue'), meta: { title: '采购取消审核', icon: 'el-icon-close' } },

      { path: 'lend', name: 'Lend', component: () => import('../views/lend/LendList.vue'), meta: { title: '借出列表', icon: 'el-icon-share' } },
      { path: 'lendApprove1', name: 'LendApprove1', component: () => import('../views/lend/LendApprove1.vue'), meta: { title: '借出初级审核', icon: 'el-icon-check' } },
      { path: 'lendApprove2', name: 'LendApprove2', component: () => import('../views/lend/LendApprove2.vue'), meta: { title: '借出终级审核', icon: 'el-icon-finished' } },
      { path: 'lendReturn', name: 'LendReturn', component: () => import('../views/lend/LendReturn.vue'), meta: { title: '借出归还列表', icon: 'el-icon-refresh-left' } },
      { path: 'lendCancel', name: 'LendCancel', component: () => import('../views/lend/LendCancel.vue'), meta: { title: '借出取消审核', icon: 'el-icon-close' } },

      { path: 'allocation', name: 'Allocation', component: () => import('../views/allocation/AllocationList.vue'), meta: { title: '调拨列表', icon: 'el-icon-rank' } },
      { path: 'allocationApprove', name: 'AllocationApprove', component: () => import('../views/allocation/AllocationApprove.vue'), meta: { title: '调拨审核', icon: 'el-icon-check' } },
      { path: 'allocationConfirm', name: 'AllocationConfirm', component: () => import('../views/allocation/AllocationConfirm.vue'), meta: { title: '调拨确认', icon: 'el-icon-s-claim' } },
      { path: 'allocationCancel', name: 'AllocationCancel', component: () => import('../views/allocation/AllocationCancel.vue'), meta: { title: '调拨取消审核', icon: 'el-icon-close' } },

      { path: 'repair', name: 'Repair', component: () => import('../views/repair/RepairList.vue'), meta: { title: '报修列表', icon: 'el-icon-warning-outline' } },
      { path: 'repairApprove', name: 'RepairApprove', component: () => import('../views/repair/RepairApprove.vue'), meta: { title: '报修审核', icon: 'el-icon-check' } },
      { path: 'repairConfirm', name: 'RepairConfirm', component: () => import('../views/repair/RepairConfirm.vue'), meta: { title: '确认报修', icon: 'el-icon-s-claim' } },
      { path: 'repairDone', name: 'RepairDone', component: () => import('../views/repair/RepairDone.vue'), meta: { title: '检修完成', icon: 'el-icon-circle-check' } },
      { path: 'repairCancel', name: 'RepairCancel', component: () => import('../views/repair/RepairCancel.vue'), meta: { title: '报修取消审核', icon: 'el-icon-close' } },

      { path: 'disposal', name: 'Disposal', component: () => import('../views/disposal/DisposalList.vue'), meta: { title: '报废列表', icon: 'el-icon-delete' } },
      { path: 'disposalApprove', name: 'DisposalApprove', component: () => import('../views/disposal/DisposalApprove.vue'), meta: { title: '报废审核', icon: 'el-icon-check' } },
      { path: 'disposalConfirm', name: 'DisposalConfirm', component: () => import('../views/disposal/DisposalConfirm.vue'), meta: { title: '报废确认', icon: 'el-icon-s-claim' } },
      { path: 'disposalCancel', name: 'DisposalCancel', component: () => import('../views/disposal/DisposalCancel.vue'), meta: { title: '报废取消审核', icon: 'el-icon-close' } },

      { path: 'consumable', name: 'Consumable', component: () => import('../views/consumable/ConsumableList.vue'), meta: { title: '易耗品列表', icon: 'el-icon-box' } },
      { path: 'consumableIssue', name: 'ConsumableIssue', component: () => import('../views/consumable/ConsumableIssue.vue'), meta: { title: '低值领用列表', icon: 'el-icon-s-order' } },

      { path: 'report', name: 'Report', component: () => import('../views/report/ReportSummary.vue'), meta: { title: '统计汇总', icon: 'el-icon-data-analysis' } },
      { path: 'reportAssetCategory', name: 'ReportAssetCategory', component: () => import('../views/report/ReportAssetCategory.vue'), meta: { title: '资产分类汇总表', icon: 'el-icon-pie-chart' } },
      { path: 'reportDepartment', name: 'ReportDepartment', component: () => import('../views/report/ReportDepartment.vue'), meta: { title: '公司部门汇总表', icon: 'el-icon-office-building' } },
      { path: 'reportDepreciationSummary', name: 'ReportDepreciationSummary', component: () => import('../views/report/ReportDepreciationSummary.vue'), meta: { title: '折旧汇总表', icon: 'el-icon-s-marketing' } },
      { path: 'reportDepreciationStat', name: 'ReportDepreciationStat', component: () => import('../views/report/ReportDepreciationStat.vue'), meta: { title: '折旧统计', icon: 'el-icon-data-line' } },
      { path: 'reportDepreciationDetail', name: 'ReportDepreciationDetail', component: () => import('../views/report/ReportDepreciationDetail.vue'), meta: { title: '折旧明细', icon: 'el-icon-tickets' } },

      { path: 'alarmList', name: 'AlarmList', component: () => import('../views/alarm/AlarmList.vue'), meta: { title: '报警列表', icon: 'el-icon-bell' } },
      { path: 'positioning', name: 'Positioning', component: () => import('../views/alarm/Positioning.vue'), meta: { title: '定位管理', icon: 'el-icon-location' } },

      { path: 'orgManage', name: 'OrgManage', component: () => import('../views/system/OrgManage.vue'), meta: { title: '组织机构管理', icon: 'el-icon-s-grid' } },
      { path: 'dictManage', name: 'DictManage', component: () => import('../views/system/DictManage.vue'), meta: { title: '数据字典管理', icon: 'el-icon-collection-tag' } },
      { path: 'sysLog', name: 'SysLog', component: () => import('../views/system/SysLog.vue'), meta: { title: '日志管理', icon: 'el-icon-notebook-2' } },
      { path: 'depreciationConfig', name: 'DepreciationConfig', component: () => import('../views/system/DepreciationConfig.vue'), meta: { title: '折旧管理', icon: 'el-icon-s-operation' } },
      { path: 'workloadConfig', name: 'WorkloadConfig', component: () => import('../views/system/WorkloadConfig.vue'), meta: { title: '工作量设置', icon: 'el-icon-setting' } },
      { path: 'sysUser', name: 'SysUser', component: () => import('../views/system/UserManage.vue'), meta: { title: '用户管理', icon: 'el-icon-user-solid' } },
      { path: 'sysRole', name: 'SysRole', component: () => import('../views/system/RoleMenu.vue'), meta: { title: '角色管理', icon: 'el-icon-s-tools' } },
      { path: 'openAccount', name: 'OpenAccount', component: () => import('../views/system/OpenAccount.vue'), meta: { title: '租户管理', icon: 'el-icon-office-building' } }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to) {
    if (to.hash) return { selector: to.hash }
    return { x: 0, y: 0 }
  }
})

function upsertMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content || '')
}

/** Cookie 里残留过期 JWT 时，先清掉，避免误进系统后连发多个 401 弹窗 */
function isTokenExpired(token) {
  if (!token || typeof token !== 'string') return true
  const parts = token.split('.')
  if (parts.length < 2) return true
  try {
    const json = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const padded = json + '==='.slice((json.length + 3) % 4)
    const payload = JSON.parse(atob(padded))
    if (!payload.exp) return false
    return payload.exp * 1000 <= Date.now()
  } catch (e) {
    return true
  }
}

router.beforeEach((to, from, next) => {
  const site = '灵犀资产 · FAMS'
  const pageTitle = (to.meta && to.meta.title) || site
  document.title = to.name === 'Landing' ? `${site} — AI建档 · RFID盘点 · 国标分类` : `${pageTitle} - ${site}`
  upsertMeta(
    'description',
    (to.meta && to.meta.description)
      || '灵犀资产 · FAMS 固定资产管理系统：AI拍物品识别建档、RFID盘点闭环、国标GB/T 14885分类。'
  )
  upsertMeta('robots', to.meta && to.meta.noindex ? 'noindex,nofollow' : 'index,follow')

  let token = store.state.token
  if (token && isTokenExpired(token)) {
    store.commit('LOGOUT')
    token = ''
  }

  const isPublic = to.matched.some(r => r.meta && r.meta.public)

  if (token && (to.name === 'Landing' || to.path === '/login' || to.path === '/register')) {
    next('/dashboard')
    return
  }
  if (!token && !isPublic) {
    next('/')
    return
  }
  if (token) {
    const routePath = to.path.replace(/^\//, '')
    if (routePath && to.matched.length > 1 && !canAccessPath(store.state.userInfo, routePath)) {
      next('/dashboard')
      return
    }
  }
  next()
})

export default router
